/* eslint-disable vue/one-component-per-file */
// 汇总行
import { ColDef, GridOptions, GridApi } from 'ag-grid-community';
import { PlainObject } from '../../core/types';
import { isString, noop } from 'lodash-es';

type RealSummaryFunc = {
  init: () => any;
  func: (v: any, r: any, row: PlainObject) => any;
  finalize: (r: any) => any;
};

export type SummaryFunc = 'sum' | 'count' | RealSummaryFunc;

// 内置函数
const builtinFuncs: Record<string, RealSummaryFunc> = {
  sum: {
    init: () => 0,
    func: (v, r) => {
      if (isNaN(v)) return r;
      return Number(v) + r;
    },
    finalize: (r: any) => r
  },

  count: {
    init: () => 0,
    func: (v, r) => {
      if (v === '' || v === 'undefined' || v === null) return r;

      return r + 1;
    },
    finalize: (r: any) => r
  }
};

function calculate(
  api: GridApi,
  summaryColumns: Record<string, SummaryFunc>,
  forEach: (cb: (row: PlainObject) => void) => void,
  titleColName: string | undefined
) {
  const pinnedRow: PlainObject = {};

  for (const [name, func] of Object.entries(summaryColumns)) {
    let realFunc: RealSummaryFunc;
    if (isString(func)) {
      realFunc = builtinFuncs[func];
    } else {
      realFunc = func;
    }

    // 计算值
    let s = realFunc.init();

    forEach((row: PlainObject) => {
      s = realFunc.func(row[name], s, row);
    });

    pinnedRow[name] = realFunc.finalize(s);
  }

  if (titleColName) {
    pinnedRow[titleColName] = '合计';
  }

  api.setPinnedBottomRowData([pinnedRow]);
}

export function useSummaryRow(colDefs: ColDef[], options: GridOptions<any>) {
  const summaryColumns: Record<string, SummaryFunc> = {};

  for (const colDef of colDefs) {
    const summaryFunc = (colDef as any).summary as SummaryFunc;
    if (summaryFunc) {
      summaryColumns[colDef.field!] = summaryFunc;

      Reflect.deleteProperty(colDef, 'summary');
    }
  }

  if (Object.keys(summaryColumns).length == 0) {
    return {
      enableSummaryRow: false,
      refresh: noop
    };
  }

  const leftFixCol =
    colDefs.find((c) => c.field == '__checkbox') ||
    colDefs.find((c) => c.field == '__seq');

  // 显示“合计”两个字的列
  const titleColName = leftFixCol?.field;

  // 取api
  let api: GridApi;
  // 重算汇总行
  const refreshSummaryRow = () => {
    if (!api) return;

    const forEach = (cb: (row: PlainObject) => void) => {
      api.forEachNode((node) => cb(node.data));
    };

    calculate(api, summaryColumns, forEach, titleColName);
  };

  const onGridReady = options.onGridReady;
  options.onGridReady = (params) => {
    onGridReady?.(params);
    api = params.api;
  };

  // 行数据改造变化
  const onRowDataUpdated = options.onRowDataUpdated;
  options.onRowDataUpdated = (params) => {
    onRowDataUpdated?.(params);

    refreshSummaryRow();
  };

  // const onVirtualRowRemoved = options.onVirtualRowRemoved;
  // options.onVirtualRowRemoved = (params) => {
  //   onVirtualRowRemoved?.(params);
  //   refreshSummaryRow();
  // };

  const refresh = (rows: any[] | undefined) => {
    if (!rows) {
      refreshSummaryRow();
      return;
    }

    const forEach = (cb: (row: PlainObject) => void) => {
      rows.forEach(cb);
    };

    calculate(api, summaryColumns, forEach, titleColName);
  };

  return {
    enableSummaryRow: true,
    refresh
  };
}
